module.exports = __webpack_public_path__ + "static/media/школа корридор 2.89c8d6c6.jpg";